import { type BrandResponse } from '../brands/aliases';

export function stripDiacritics(str: string) {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function getFilteredBrands(
  brandData: BrandResponse,
  searchValue: string
) {
  const searchRegex = new RegExp(
    searchValue.replace(/[.*+?^=!:${}()|\[\]\/\\]/g, '\\$&'),
    'i'
  );

  const filteredOptions = Object.values(brandData).filter((brand) => {
    return searchRegex.test(stripDiacritics(brand.name).trim());
  });

  return filteredOptions;
}
